import { connect } from 'react-redux'
import addAddressSelector from './addAddressSelector'
import requestAddIncomingMail from '../../../../../sagas/requestAddIncomingMail'
import AddAddress from './AddAddress'

export default connect(
  addAddressSelector,
  {
    requestAddIncomingMail
  }
)(AddAddress)
